import { render, staticRenderFns } from "./UnsplashBackgroud.vue?vue&type=template&id=3b3b1d68&scoped=true&"
import script from "./UnsplashBackgroud.vue?vue&type=script&lang=js&"
export * from "./UnsplashBackgroud.vue?vue&type=script&lang=js&"
import style0 from "./UnsplashBackgroud.vue?vue&type=style&index=0&id=3b3b1d68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3b1d68",
  null
  
)

export default component.exports